import { DecimalPipe, NgClass } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AudioToTextService } from 'src/app/shared/services/audio-to-text/audio-to-text.service';

@Component({
  selector: 'app-audio-debugger',
  imports: [NgClass, DecimalPipe, FormsModule],
  standalone: true,
  templateUrl: './audio-debugger.component.html',
  styleUrl: './audio-debugger.component.scss'
})


export class AudioDebuggerComponent {
  public visible = false;
  constructor(public attService: AudioToTextService) {

  }

  @HostListener('document:keydown', ['$event'])
  public onKeyDPressed(event: KeyboardEvent): void {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'd') {
      event.preventDefault(); // Optional: verhindert z. B. Browser-Lesezeichen
      this.visible = !this.visible;
    }
  }
}
